import { Reducer } from 'redux'
import { IAction } from 'apps/fleet-planner/types/base'
import { ILoadCountsState } from 'apps/fleet-planner/types/loads'
import { FETCH_LOAD_COUNTS_ACTION_TYPES } from 'apps/fleet-planner/utils/actions/loadCounts'

const {
  FETCH_LOAD_COUNTS_FAILURE,
  FETCH_LOAD_COUNTS_REQUEST,
  FETCH_LOAD_COUNTS_SUCCESS,
} = FETCH_LOAD_COUNTS_ACTION_TYPES

interface ISuccessAction extends IAction {
  payload: {
    response: number[]
  }
}

type LoadCountsAction = IAction | ISuccessAction

export const defaultState: ILoadCountsState = {
  fetching: false,
  counts: [],
}

const loadCountsReducer: Reducer<ILoadCountsState, LoadCountsAction> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case FETCH_LOAD_COUNTS_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: undefined,
      }
    }

    case FETCH_LOAD_COUNTS_SUCCESS: {
      return {
        ...state,
        fetching: false,
        counts: (action as ISuccessAction).payload.response ?? [],
      }
    }

    case FETCH_LOAD_COUNTS_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: action.error,
        counts: [],
      }
    }

    default:
      return state
  }
}

export default loadCountsReducer
